'use client'

import { useEffect } from 'react'
import * as Sentry from '@sentry/nextjs'
import SiteError from '@/components/reference/SiteError'

/**
 * Error boundary for services pages
 * Catches errors and displays a branded error page with recovery options
 */
export default function ServicesError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log error to Sentry
    Sentry.captureException(error)
    console.error('Services page error:', error)
  }, [error])

  return (
    <SiteError
      error={error}
      reset={reset}
      title='Oops! Something went wrong'
      message={
        "We encountered an error while loading our services. Don't worry, our team has been notified."
      }
      links={[
        { href: '/services', label: 'All services' },
        { href: '/', label: 'Go home' },
      ]}
      help
    />
  )
}
